import { render, staticRenderFns } from "./CcActionsPopover.ts.vue?vue&type=template&id=0454e1ba"
import script from "./CcActionsPopover.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcActionsPopover.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcActionsPopover.ts.vue?vue&type=style&index=0&id=0454e1ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports